import { render, staticRenderFns } from "./Metas.vue?vue&type=template&id=56d65c07&scoped=true&"
import script from "./Metas.vue?vue&type=script&lang=js&"
export * from "./Metas.vue?vue&type=script&lang=js&"
import style0 from "./Metas.vue?vue&type=style&index=0&id=56d65c07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d65c07",
  null
  
)

component.options.__file = "Metas.vue"
export default component.exports